
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var CircuitsUtil = require("../../../util/CircuitsUtil.js");
var AssetDetailsLink = require("../AssetDetailsLink.jsx");

class UploadNewVersion extends React.Component  {
    constructor(){
        super()
    }



    render(){
        const { id, name } = this.props.resource;
        let source = CircuitsUtil.getSource(this.props.resource);
        return <AssetDetailsLink 
                    {...this.props}
                    Content={()=>"Upload New Version"}
                    mainClass="button blue responsible-library-info"
                    removeDisable={this.props.current_user_id !== this.props.resource.user_id}
                    objUrl={{ pathname: `/newversion/${id}/${name}`, state: { modal: true, source }}} // this works?
               />
    }
}

module.exports = UploadNewVersion;